/* -- Angular Dependencies -- */
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
/* -- 3rd party Dependencies -- */
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BannerNotificationsService, ExceptionService, LocalStorageService, SpinnerService, UtilsService } from '../xform-compat';
/* -- Singleton Services -- */
import { EventsHubService } from './events-hub.service';
import { AuthInterceptor } from './auth-interceptor';
import { throwIfAlreadyLoaded } from './module-import-guard';
import {
  TextContentService,
  ChartService,
  FinancialUtilsService,
  DateTimeService,
  TemplateModalService,
  CompanyEventsService,
  ExecDashboardUtilsService,
  InsightsEventsService,
  MediaService,
  NotificationsService,
  PermissionsChangedLogoutService,
} from './services';
/* -- App Components -- */
import { SpinnerComponent } from '../shared/components/spinner/spinner.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { BannerNotificationsComponent } from '../shared/components/banner-notifications/banner-notifications.component';
import { TaraIconComponent } from '../shared/components/tara-icon/tara-icon.component';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatTab, MatTabGroup } from '@angular/material/tabs';


@NgModule({
  imports: [
    CommonModule, FormsModule, RouterModule, TranslateModule, HttpClientModule, NgbModule,
    SweetAlert2Module.forRoot(), MatMenu, MatTabGroup, MatTab, MatMenuTrigger
  ],
  exports: [
    CommonModule, FormsModule, RouterModule, TranslateModule, HttpClientModule, NgbModule, SweetAlert2Module,
    PageNotFoundComponent, SpinnerComponent, BannerNotificationsComponent, TaraIconComponent
  ],
  declarations: [PageNotFoundComponent, SpinnerComponent, BannerNotificationsComponent, TaraIconComponent],
  providers: [
    EventsHubService, TemplateModalService, CurrencyPipe,
    LocalStorageService, TranslateService, SpinnerService, BannerNotificationsService, UtilsService, HttpClient,
    DateTimeService, FinancialUtilsService, ChartService, TextContentService,
    CompanyEventsService, ExecDashboardUtilsService, InsightsEventsService, MediaService, NotificationsService,
    ExceptionService, PermissionsChangedLogoutService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
